// src/utils/ttmQrLog.js
// TEMP diagnostic: records the QR decode envelope per upload so you can build a
// real decode-floor table from field shots. Delete once the PPI threshold is set.

const STORAGE_KEY = "ttm_qr_envelope_log";

const load = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
  catch { return []; }
};
const save = (rows) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(rows)); } catch (_) {}
};

export function logQrSample(row) {
  const rows = load();
  const entry = { t: new Date().toISOString(), ...row };
  rows.push(entry);
  save(rows);
  console.log("%c[QR-LOG]", "color:#0057b8;font-weight:bold", `#${rows.length}`, entry);
}

// Run in the console: ttmQrDump()  -> prints a table and copies CSV to clipboard.
export function ttmQrDump() {
  const rows = load();
  if (!rows.length) { console.log("[QR-LOG] empty"); return; }
  console.table(rows);
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => JSON.stringify(r[h] ?? "")).join(",")),
  ].join("\n");
  try {
    navigator.clipboard.writeText(csv);
    console.log("%c[QR-LOG] CSV copied — paste into Sheets.", "color:#16a34a;font-weight:bold");
  } catch (_) {
    console.log("[QR-LOG] clipboard blocked, CSV below:\n" + csv);
  }
  return csv;
}

// Run in the console: ttmQrClear()
export function ttmQrClear() { save([]); console.log("[QR-LOG] cleared"); }

if (typeof window !== "undefined") {
  window.ttmQrDump = ttmQrDump;
  window.ttmQrClear = ttmQrClear;
}
